import { useCallback, useEffect, useRef, useState } from "react";
import { getExpertiseAdminDetail } from "../../services/partnerExpertService";
import { ExpertiseDetailModel } from "./models/ExpertiseDetailModel";

export const useExpertiseDetails = (id: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState<ExpertiseDetailModel | null>(null);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            setDetails(null);
            const _result = await getExpertiseAdminDetail(id)
            if(!isMountedRef.current)
                return;
            setDetails(_result);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        load();
    }, [load]);

    // PR-I-87 — reload() se expone para que el drawer refresque el detalle tras approve/decline
    // sin remontar el modal (evita parpadeo y mantiene scroll/estado del usuario).
    return { loading, details, reload: load }
}